export const GET_COMPLIANCE_LEDGER_STATUS = gql`
  query GetComplianceLedgerStatus($id: String!) {
    complianceLedger(id: $id) {
      id
      status
    }
  }
`
